import React from 'react';
import Navbar from '../sections/Navbar';
import { useScrollToHash } from '../hooks/useScrollToHash';
import Hero from '../sections/Hero';
import Features from '../sections/Features';
import Testimonials from '../sections/Testimonials';

import Pricing from '../sections/Princing';
import CTASection from '../sections/CTASection';
import PartenairesSection from '../sections/PartenairesSection';
import ContactSection from '../sections/ContactSection';
import Footer from '../sections/Footer';
import BannerHomepage from '../components/HomePage/BannerHomepage';
import TestimonialsVideo from'../sections/TestimonialsVideo';
import Frequence from'../sections/Frequence';

const WA_LINK =
  'https://wa.me/221788267700?text=Bonjour%20je%20faisais%20un%20tour%20sur%20votre%20site%20et%20votre%20solution%20m%E2%80%99int%C3%A9resse%2C%20j%E2%80%99aimerais%20en%20savoir%20plus';

function WhatsAppFab() {
  return (
    <a
      href={WA_LINK}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Nous contacter sur WhatsApp"
      className="
        group fixed bottom-6 right-6 z-50
        flex items-center gap-0 overflow-hidden
        bg-[#25D366] text-white
        rounded-full shadow-lg
        h-[52px] w-[52px]
        hover:w-[190px]
        transition-all duration-300 ease-in-out
        no-underline
      "
      style={{ textDecoration: 'none' }}
    >
      {/* Icône WhatsApp */}
      <span className="flex items-center justify-center shrink-0 w-[52px] h-[52px]">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
          fill="white"
          width="26"
          height="26"
          aria-hidden="true"
        >
          <path d="M16 0C7.163 0 0 7.163 0 16c0 2.822.736 5.476 2.027 7.782L0 32l8.418-2.004A15.94 15.94 0 0016 32c8.837 0 16-7.163 16-16S24.837 0 16 0zm0 29.333a13.27 13.27 0 01-6.77-1.854l-.485-.288-5.002 1.191 1.217-4.866-.317-.5A13.267 13.267 0 012.667 16C2.667 8.636 8.636 2.667 16 2.667S29.333 8.636 29.333 16 23.364 29.333 16 29.333zm7.274-9.972c-.398-.2-2.355-1.163-2.72-1.295-.365-.133-.631-.2-.897.2-.265.398-1.03 1.295-1.263 1.562-.232.265-.465.298-.863.1-.398-.2-1.682-.62-3.203-1.977-1.184-1.056-1.983-2.36-2.215-2.758-.232-.398-.025-.613.175-.812.18-.179.398-.465.597-.698.2-.232.265-.398.398-.664.133-.265.066-.498-.033-.698-.1-.2-.897-2.162-1.23-2.96-.324-.778-.652-.673-.897-.685l-.764-.013c-.265 0-.697.1-1.063.498-.365.398-1.396 1.363-1.396 3.325s1.43 3.857 1.628 4.122c.2.265 2.815 4.298 6.82 6.026.953.412 1.697.658 2.277.842.957.305 1.829.262 2.518.159.768-.115 2.355-.963 2.688-1.893.333-.93.333-1.727.232-1.893-.1-.166-.365-.265-.763-.465z" />
        </svg>
      </span>

      {/* Label visible au survol */}
      <span
        className="
          whitespace-nowrap text-[13px] font-bold pr-4
          opacity-0 group-hover:opacity-100
          transition-opacity duration-200 delay-100
        "
      >
        Contactez-nous
      </span>
    </a>
  );
}

export default function LandingPage() {
  useScrollToHash(true);

  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Features/>
        <Testimonials/>
        <Pricing/>
        <CTASection/>
        <PartenairesSection/>
        <BannerHomepage/>
        <TestimonialsVideo/>
        <Frequence/>
        <ContactSection/>
        <Footer/>
      </main>
      <WhatsAppFab />
    </>
  );
}